<template>
	<div class="ReSearchScndFlatBig" v-if="objData">		
		<card>            
			<div class="flatHeader mb-3">
				<div class="flatTitles">
					<div class="row px-3">						
						<h4 class="mr-3">{{objData.title}}</h4>
					</div>
					<div class="row px-3">
						<p class="mr-3" v-if="typeof objData.creationDate !='undefined' || objData.creationDate!=''">Добавлено {{$GVO.convertDateTimeFromMysql(objData.creationDate)}}</p>
						<p v-if="typeof objData.lastUpdateDate !='undefined' || objData.lastUpdateDate!=''">Обновлено {{$GVO.convertDateTimeFromMysql(objData.lastUpdateDate)}}</p>                 
					</div>
					<div class="row align-items-center mx-0 mt-3">
						<span class="badge badge-primary mr-2" v-if="objData.source!='' || objData.source!=null">{{objData.source}}</span>
						<span class="badge badge-primary mr-2" v-if="objData.salesType!='' || objData.salesType!=null">{{objData.salesType}}</span>
						<a :href="objData.url" target="_blank" v-if="(objData.url!='' || objData.url!=null) && objData.source!=''">Объект на {{objData.source}}</a>
						<span class="badge badge-danger mr-2" style="font-size: 12px;" v-if="objData.act =='0'">Объект в архиве</span>
					</div>
				</div>
				<div class="row mx-0 align-items-center">
					<div class="bntGroup">
						<base-button type="primary" class="groupfloor" simple @click="backByHistory()" ><i class="tim-icons icon-double-left mr-2"></i>Назад</base-button>
					</div>			
					
					<div class="flatHeader-btn ml-3" v-if="typeof $GVO.GetAllGet().taskend_id != 'undefined'">
						<base-button v-if="parseInt(objData.inPresentation)==0" type="primary" simple  @click="AddToPres()"><i class="tim-icons icon-book-bookmark mr-2"></i>Добавить к презентациям</base-button>
						<base-button  v-else type="primary" simple @click="GoToPres()"><i class="tim-icons icon-book-bookmark mr-2"></i>В презентации</base-button>
					</div>
				</div>
			</div>

			<div class="flatInfo mb-5">
				<div class="col-sm-12 col-md-6 flatPhotos">
					<div class="flat-carousel mb-4">
						<el-carousel :autoplay="false" arrow="always" height="400px" v-if="masObjImages != ''">
							<el-carousel-item v-for="obj_img in masObjImages" :key="obj_img.filename">
								<img v-if="obj_img !=''" :src="obj_img.filename" alt="">
							</el-carousel-item>
						</el-carousel>
						<div>
							<img v-if="masObjImages == ''" src="/img/flatsDefault.svg" style="height: 100%;" alt=""> 
						</div>
					</div>
					<div class="row" v-if="objData.description!='' || objData.description!=null">
						<div class="col-sm-12">
							<h4>Описание</h4>
							<div class="objectDescr"><p>{{objData.description}}</p></div>
						</div>
					</div>

				</div>
				<div class="col-sm-12 col-md-5 flatPass px-4">
					<collapse activeIndexType="all">
						<collapse-item :title="flatPass" >
							<div class="flatPass-container">
								<div class="flatPass-row"><h3>{{$GVO.number_format(objData.price,0,'.',' ')}} ₽</h3></div> 
								<div class="flatPass-row objDots" v-if="objData.area!=null"><p>S общая</p><span></span><p>{{$GVO.number_format(objData.area,0,'.',' ')}} м²</p></div>
								<div class="flatPass-row objDots" v-if="objData.kitchenSpace!=null"><p>S кухни</p><span></span><p>{{objData.kitchenSpace}} м²</p></div> 
								<div class="flatPass-row objDots" v-if="(objData.floor!=null) || (objData.floors!=null)"><p>Этаж/Этажность</p><span></span><p>{{objData.floor}}  /  {{objData.floors}} </p></div>
								<div class="flatPass-row objDots" v-if="objData.salesType!=null"><p>Тип клиента </p> <span></span><p>{{objData.salesType}}</p></div>
								<div class="flatPass-row objDots" v-if="objData.salesAgentName!=null"><p>Агент </p><span></span><router-link v-if="objData.staff_code != null && objData.staff_code != ''" :to="'/data/staff/id/'+objData.staff_code">{{objData.salesAgentName}}</router-link><p v-else>{{objData.salesAgentName}}</p></div>
							</div>
							<!-- <div class="flatPass-btn">
								<base-button type="success" simple @click="Call(objData.salesAgentPhone,'CLIENT',objClient.id)">Позвонить objData.salesAgentPhone</base-button>
							</div> -->		
							<p class="mr-1">Ответственные за ячейку:</p>					
							<ul class="cell-agent">
								
								<li class="mr-3" v-for="agent in objData.cellInfo" :key="agent.index" :objData="agent">
									<p class="mr-1">Ячейка {{agent.cellId}} "{{agent.cellName}}"</p>
									<router-link :to="'/data/staff/id/'+agent.agentId" class="mr-1"> {{agent.agentName}}, </router-link>
									<!-- <a v-for="agent in objData.cellInfo" :key="agent.index" :objData="agent" :href="'/data/staff/id/'+agent.agentId" class="mr-1">{{agent.agentName}}, </a> -->
								</li>
							</ul>
							<!-- <hr v-if="objData.result_name!=null"> -->
							<div class="flatPass-container" v-if="objData.result_name!=null">	
								<div class="callClass px-3 pt-2">							
									<div class="flatPass-row" v-if="objData.result_name!=null"><p>Классификация звонка: {{objData.result_name}}</p></div>
									<div class="flatPass-row" v-if="objData.result_descr!=null && objData.result_descr!='0'"><p>Примечание звонка: {{objData.result_descr}}</p></div>
								</div>
							</div>
							
						</collapse-item>
					</collapse>     
				</div>
			</div>
			
			<div class="objectInfo mb-5 pb-4">    
				<div class="col-sm-12 col-md-6 windowMap">
					<h4>Расположение</h4>
					<div class="objectAddress">
						<div class="metro">
							<div class="row flex-nowrap ml-0 mr-2 align-items-top" v-if="objData.metroName!=null  && objData.metroName!=''">
								<i class="tim-ic ic-metro text-primary mr-1"></i>
								<p>метро {{objData.metroName}}, </p>									
							</div> 								
							<div class="row ml-0 mr-2 align-items-center" v-if="objData.fromSubway!=null  && objData.fromSubway!='' && objData.fromSubway !='0.00'">
								<p>{{objData.fromSubway}} км</p>									
							</div> 								
						</div>
						<div class="mb-3"><p>
							<span v-if="objData.region && objData.region!='' && objData.houseAddress == ''"> {{ objData.region }}, </span>  
							<span v-if="objData.district && objData.district!='' && objData.houseAddress == ''"> {{ objData.district }}, </span>  

							<span v-if="objData.address && objData.address!=''"> {{ objData.address }}</span>  
							<span v-if="objData.houseAddress && objData.houseAddress!=''"> {{ objData.houseAddress }}</span>  
							

						</p> </div>
					</div>
					<div class="map mt-2">
						<!--div class="embed-responsive embed-responsive-16by9" v-if="objData.gid != ''">
							<iframe class="embed-responsive-item" :src="`https://web.3bita.ru/floorplan/widgets/widget.html?gid=${objData.gid}&zoom=17&caption=false`" allowfullscreen allowusermedia></iframe>
						</!--div-->
						<!--ниже то что для v-else-->
						<div>
							<yandex-map
								:settings="yamap_settings"
								:coords="yamap_coords"
								:zoom="yamap_zoom"
								:scroll-zoom="false"
								:controls="yamap_controls"
								>
							
								<ymap-marker
										:coords="yamap_markers.coords"
										:marker-id="yamap_markers.id"
										marker-type="placemark"
								/>

							</yandex-map>
						</div>
					</div>
				</div>

				<div class="col-sm-12 col-md-5 flatPass px-4">
					<collapse activeIndexType="single" :activeIndex="0">
						<collapse-item title="Главное" class="mt-4" name="1"  >
							<!-- <div class="flatPass-row" v-if="objData.builtYear!=null"><p>Год постройки</p><p>{{objData.builtYear}}</p></div> -->
							<div class="flatPass-row objDots" v-if="objData.houseStartYear!=null"><p>Год ввода в эксплуатацию</p><span></span><p>{{objData.houseStartYear}}</p></div>
							<div class="flatPass-row objDots"><p>Класс</p><span></span><p>{{objData.houseCatLivingClassName}}</p></div>
							<div class="flatPass-row objDots" v-if="objData.houseSeries!=null"><p>Серия, тип постройки</p><span></span><p>{{objData.houseSeries}}</p></div>
							<div class="flatPass-row objDots" v-if="objData.houseSeriesBuilding!=null"><p>Серия, тип постройки здания</p><span></span><p>{{objData.houseSeriesBuilding}}</p></div>
							<div class="flatPass-row objDots" v-if="objData.houseHouseType!=null"><p>Тип дома</p><span></span><p>{{objData.houseHouseType}}</p></div>
							<div class="flatPass-row objDots" v-if="objData.houseEmergency!=null"><p>Аварийность</p><span></span><p>{{objData.houseEmergency}}</p></div>
							<div class="flatPass-row objDots" v-if="objData.houseCadastrNumber!=null"><p>Кадастровый номер</p><span></span><p>{{objData.houseCadastrNumber}}</p></div>
							<div class="flatPass-row objDots" v-if="objData.houseManagCompany!=null"><p>Управляющая компания</p><span></span><p>{{objData.houseManagCompany}}</p></div>
							<div class="flatPass-row objDots" v-if="objData.houseDescr!=null"><p>Дополнительная информация</p><span></span><p>{{objData.houseDescr}}</p></div>
						</collapse-item>
						<collapse-item title="Инфраструктура" class="mt-4">
							<div class="flatPass-row objDots" v-if="objData.housePlayground!=null"><p>Детская площадка</p><span></span><p>{{objData.housePlayground}}</p></div>
							<div class="flatPass-row objDots" v-if="objData.houseSportsground!=null"><p>Спортивная площадка</p><span></span><p>{{objData.houseSportsground}}</p></div>
						</collapse-item>
						<collapse-item title="Площадь" class="mt-4">
							<div class="flatPass-row objDots" v-if="objData.houseSCommonLand!=null"><p>Площадь зем. участка общего имущества</p><span></span><p>{{objData.houseSCommonLand}} м²</p></div>
							<div class="flatPass-row objDots" v-if="objData.houseSCommonPlaces!=null"><p>Площадь помещений общего имущества</p><span></span><p>{{objData.houseSCommonPlaces}} м²</p></div>
							<div class="flatPass-row objDots" v-if="objData.houseSLivingPlaces!=null"><p>Площадь жилых помещений</p><span></span><p>{{objData.houseSLivingPlaces}} м²</p></div>
							<div class="flatPass-row objDots" v-if="objData.houseSNonlivingPlaces!=null"><p>Площадь нежилых помещений</p><span></span><p>{{objData.houseSNonlivingPlaces}} м²</p></div>
							<div class="flatPass-row objDots" v-if="objData.houseSParking!=null"><p>Площадь парковки</p><span></span><p>{{objData.houseSParking}} м²</p></div>
							<div class="flatPass-row objDots" v-if="objData.houseSBasement!=null"><p>Площадь подвала</p><span></span><p>{{objData.houseSBasement}} м²</p></div>
						</collapse-item>
						<collapse-item title="Снабжение" class="mt-4">
							<div class="flatPass-row objDots" v-if="objData.houseColdWater!=null"><p>Холодное водоснабжение</p><span></span><p>{{objData.houseColdWater}}</p></div>
							<div class="flatPass-row objDots" v-if="objData.houseHotWater!=null"><p>Горячее водоснабжение</p><span></span><p>{{objData.houseHotWater}}</p></div>
							<div class="flatPass-row objDots" v-if="objData.houseGas!=null"><p>Газоснабжение</p><span></span><p>{{objData.houseGas}}</p></div>
							<div class="flatPass-row objDots" v-if="objData.houseHeatsupply!=null"><p>Теплоснабжение</p><span></span><p>{{objData.houseHeatsupply}}</p></div>
							<div class="flatPass-row objDots" v-if="objData.housePowersupply!=null"><p>Электроснабжение</p><span></span><p>{{objData.housePowersupply}}</p></div>
							<div class="flatPass-row objDots" v-if="objData.houseFireSystem!=null"><p>Система пожаротушения</p><span></span><p>{{objData.houseFireSystem}}</p></div>
						</collapse-item>
						<collapse-item title="Этажность" class="mt-4">
							<div class="flatPass-row objDots" v-if="objData.houseFloorCount!=null"><p>Количество этажей</p><span></span><p>{{objData.houseFloorCount}}</p></div>
							<div class="flatPass-row objDots" v-if="objData.houseFloorsMax!=null"><p>Наибольшее количество этажей</p><span></span><p>{{objData.houseFloorsMax}}</p></div>
							<div class="flatPass-row objDots" v-if="objData.houseFloorsMin!=null"><p>Наименьшее количество этажей</p><span></span><p>{{objData.houseFloorsMin}}</p></div>
						</collapse-item>
						<collapse-item title="Количество помещений" class="mt-4">
							<div class="flatPass-row objDots" v-if="objData.houseLivingPlaces!=null"><p>Жилых помещений</p><span></span><p>{{objData.houseLivingPlaces}}</p></div>
							<div class="flatPass-row objDots" v-if="objData.houseLivingPlacesCount!=null"><p>Количество жилых помещений</p><span></span><p>{{objData.houseLivingPlacesCount}}</p></div>
							<div class="flatPass-row objDots" v-if="objData.houseNonlivingPlaces!=null"><p>Количество нежилых помещений</p><span></span><p>{{objData.houseNonlivingPlaces}}</p></div>
						</collapse-item>
						<collapse-item title="Мусоропровод" class="mt-4">
							<div class="flatPass-row objDots" v-if="objData.houseGarbage!=null"><p>Мусоропровод</p><span></span><p>{{objData.houseGarbage}}</p></div>
							<div class="flatPass-row objDots" v-if="objData.houseGarbageNumber!=null"><p>Количество мусоропроводов</p><span></span><p>{{objData.houseGarbageNumber}}</p></div>
							<div class="flatPass-row objDots" v-if="objData.houseGarbageType!=null"><p>Тип мусоропровода</p><span></span><p>{{objData.houseGarbageType}}</p></div>
						</collapse-item>
						<collapse-item title="Материалы" class="mt-4">
							<div class="flatPass-row" v-if="objData.ouseMainWalls!=null"><p>Несущие стены</p><span></span><p>{{objData.ouseMainWalls}}</p></div>
							<!-- <div class="flatPass-row"><p>Материал несущих стен</p><p>wall_material Кирпич</p></div> -->
							<div class="flatPass-row objDots" v-if="objData.houseOverlapType!=null"><p>Тип перекрытий</p><span></span><p>{{objData.houseOverlapType}}</p></div>
							<div class="flatPass-row objDots" v-if="objData.houseOverlapping!=null"><p>Перекрытия</p><span></span><p>{{objData.houseOverlapping}}</p></div>
							<div class="flatPass-row objDots" v-if="objData.houseRoof!=null"><p>Крыша</p><span></span><p>{{objData.houseRoof}}</p></div>
							<div class="flatPass-row objDots" v-if="objData.houseFacade!=null"><p>Фасад</p><span></span><p>{{objData.houseFacade}}</p></div>
							<div class="flatPass-row objDots" v-if="objData.houseBasement!=null"><p>Фундамент</p><span></span><p>{{objData.houseBasement}}</p></div>	
							<div class="flatPass-row objDots" v-if="objData.houseEquipment!=null"><p>Оборудование</p><span></span><p>{{objData.houseEquipment}}</p></div>
						</collapse-item>
						<collapse-item title="Лифты" class="mt-4">
							<div class="flatPass-row objDots" v-if="objData.houseLifts!=null"><p>Лифты</p><span></span><p>{{objData.houseLifts}}</p></div>
							<div class="flatPass-row objDots" v-if="objData.houseLiftsCount!=null"><p>Количество лифтов</p><span></span><p>{{objData.houseLiftsCount}}</p></div>
						</collapse-item>
						<collapse-item title="Другое" class="mt-4">
							<div class="flatPass-row objDots" v-if="objData.houseEfficiencyClass!=null"><p>Класс энергетической эффективности</p><span></span><p>{{objData.houseEfficiencyClass}}</p></div>
							<div class="flatPass-row objDots" v-if="objData.houseEntrancesCount!=null"><p>Количество подъездов</p><span></span><p> {{objData.houseEntrancesCount}}</p></div>
							<div class="flatPass-row objDots" v-if="objData.houseTechEntr!=null"><p>Количество входов в дом</p><span></span><p> {{objData.houseTechEntr}}</p></div>
							<div class="flatPass-row objDots" v-if="objData.houseCapitalRepairFund!=null"><p>Формирование фонда кап. ремонта</p><span></span><p> {{objData.houseCapitalRepairFund}}</p></div>
							<div class="flatPass-row objDots" v-if="objData.houseCesspools!=null"><p>Объем выгребных ям</p><span></span><p> {{objData.houseCesspools}} куб.м.</p></div>
							<div class="flatPass-row objDots" v-if="objData.houseVentilation!=null"><p>Вентиляция</p><span></span><p> {{objData.houseVentilation}}</p></div>
							<div class="flatPass-row objDots" v-if="objData.houseWastewater!=null"><p>Водоотведение</p><span></span><p> {{objData.houseWastewater}}</p></div>
							<div class="flatPass-row objDots" v-if="objData.houseWastewaterSystem!=null"><p>Система водостоков </p><span></span><p> {{objData.houseWastewaterSystem}}</p></div>
						</collapse-item>
						<!-- <collapse-item title="Иное" >
							<div class="flatPass-container">
								<div class="flatPass-row"><p>Название комплекса</p><p>{{objData.complexName}}</p></div>
								<div class="flatPass-row"><p>Тип участка</p><p>{{objData.landType}}</p></div>
								<div class="flatPass-row"><p>Охрана</p><p>{{objData.guard}}</p></div>
							</div>
						</collapse-item> -->
					</collapse>    
				</div>
			</div>
		  
		</card>        
		<!--pre>{{objData}}</pre-->
	</div>
</template>

<script>
import { Collapse, CollapseItem } from 'src/components';
import { Carousel, CarouselItem, } from "element-ui";	
// import config from '@/config';
import moment from 'moment';
import VueMoment from 'vue-moment';
import { yandexMap, ymapMarker } from 'vue-yandex-maps';
import mapSettings from 'src/conf/yandexmap.js';

export default {
	name: 'ReSearchScndFlatBig',
	components: {
		Collapse,
		CollapseItem,
		[Carousel.name]: Carousel,
		[CarouselItem.name]: CarouselItem,
		yandexMap, ymapMarker,
	},
	props: {
		objData: Object,
		findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
			type: String,
			default: '',
		},
		flatPass: {
			type: String,
			default: 'Паспорт объекта',
		},
		objectPass: {
			type: String,
			default: 'Общая информация',
		},
	},
	data () {
		return {
			ver: 1,
			yamap_settings: { ...mapSettings },
			yamap_coords: [59.93984485554249, 30.314527237792984],
			yamap_zoom: 17,
			yamap_controls:['zoomControl','typeSelector'],
			yamap_markers:{
				coords: [59.93984485554249, 30.314527237792984],
				id: '1',
			},
			masImgs:'',
			activeItem: null,
	
		}
	},
	watch: {
		objData: function(val){
			this.yamap_coords = [this.objData.latitude,this.objData.longitude];
			this.yamap_markers.coords = [this.objData.latitude,this.objData.longitude];
		}

	},
	computed: {
		masObjImages: function(){
			let masImgs = [];
			if(this.objData.image != '') {
				// console.log(this.objData.image);
				const arrImages = JSON.parse(this.objData.image);
				// console.log(arrImages);
				for (let i = 0; i < arrImages.length; i++){
					for (let value of Object.values(arrImages[i])) {
						masImgs.push({filename: value.replace(/\\/g,'')});						
						// console.log(value);
					}
				}
			}
			return masImgs;
		},
		
	},
	methods: {
		handleChange(val) {
			// console.log(val);
		},
		backByHistory(){
			this.$router.back();
		},
		GoToPres(){
			const objGetParams = this.$GVO.GetAllGet();
			//location.href=`/data/module/sso/object/second/?show_pres=1&task_id=${objGetParams.task_id}&taskend_id=${objGetParams.taskend_id}&client_id=${objGetParams.client_id}`;
			location.href=`/data/module/sso/?show_pres=1&task_id=${objGetParams.task_id}&taskend_id=${objGetParams.taskend_id}&client_id=${objGetParams.client_id}&dSearchType=flats`;
		},		
		AddToPres(){
			const objGetParams = this.$GVO.GetAllGet();
			if(!this.$GVO.isEmpty(objGetParams)){
				this.$GVO.ApiCall('INSUPD_OBJ_TO_PRES',{
					obj:'presentations',
					flt:{
						client_id:objGetParams.client_id,
						task_id:objGetParams.task_id,
						taskend_id:objGetParams.taskend_id
					},iData:{
						app_id:this.objData.id,
						type: 2
					}
				})
				.then((objApi) => {
					if(objApi.success === true){
						this.objData.inPresentation = 1;
					}
				}).catch(errorObjApi => {this.ApiData = []; console.error(errorObjApi);});
			}else{
				alert('Нет параметров задачи и клиента');
			}
		},
		
	},
	mounted(){
		if(typeof this.objData != 'undefined'){
			this.yamap_coords = [this.objData.latitude,this.objData.longitude];
			this.yamap_markers.coords = [this.objData.latitude,this.objData.longitude];
		}

	}
}
</script>
<style scoped>

.flatHeader {display: flex; padding: 15px; justify-content: space-between; flex-wrap: wrap;}
.flatHeader-btn {display: flex; flex-wrap: wrap;}
.flatTitles {display: flex; flex-direction: column;}
.flatTitles h4 {margin-bottom: 5px;}
.flatPhotos {height: auto; flex-shrink: 0;}
.flatPass {flex-shrink: 2;}
.structure-btns > button {width: 100%;}
.icon-folder {width: 18px; height: 18px; background-image: url('/img/icons/folder.svg'); background-repeat: no-repeat;  margin: 0px 7px 3px 0px;}
.flatInfo {display: flex; justify-content: space-between; flex-wrap: wrap; padding: 20px 5px 15px 15px; border-radius: 6px; border: 1px solid #01b0e0;}


/*===carousel===============================*/

.ReSearchScndFlatBig >>> button:not(:disabled),
[type="button"]:not(:disabled),
[type="reset"]:not(:disabled),
[type="submit"]:not(:disabled) {
  outline: none!important;
}
.ReSearchScndFlatBig >>>  button:focus {outline: none!important;}
.ReSearchScndFlatBig >>> .el-carousel__arrow {background-color: rgb(62, 80, 101, 0.32);}
.ReSearchScndFlatBig >>> .el-carousel__arrow--right {right: 0;}
.ReSearchScndFlatBig >>> .el-carousel__arrow--left {left: 0;}
.flatPhotos img {height: 100%; border: 1px solid transparent; margin: 0 auto; display: block; object-fit: contain;}
.objectProgress .el-carousel__item:nth-child(2n) {
  background: url("/img/73b0903ac774c473d1cd176b2fbe999f.jpeg") no-repeat center;
  background-size: contain;
} /*план поэтажный*/ 
.objectProgress .el-carousel__item:nth-child(2n + 1) {
  background: url("/img/9bht27nx4iuqcw3n0s4wyns4.png") no-repeat center;
  background-size: contain;
} /*план кв*/ 

/*===collapse===============================*/

.flatPass >>> .card-collapse .card:not(.card-cinc) .card-header {padding-top: 0px;}
.flatPass >>> .card-collapse .card:not(.card-cinc) .card-header a {color: #01b0e0;}
.flatPass >>> .card-collapse .card:not(.card-cinc) .card-body {padding-right: 0px; padding-left: 0px;}
.flatPass-container {display: flex; flex-direction: column;}
.flatPass-row {display: flex; justify-content: space-between; margin-bottom: 5px;}
.flatPass-btn {display: flex; justify-content: space-between; margin-top: 10px;}
.flatPass-btn > button {width: 100%;}
.flatPass-btn > button:first-child {margin-right: 15px;}
.flatPass-row h3, .bigPrice h3 {margin-bottom: 0px;}
.contats-booking {display: flex; flex-wrap: wrap;}

/*===map===============================*/
.objectInfo, .priceFlow  {display: flex; justify-content: space-between; flex-wrap: wrap; border: 1px solid #01b0e0; padding: 20px 5px 0px 15px; border-radius: 6px;}
.objectProgress, .mortgage, .bank-card, .mortgage-calc, .payment {border: 1px solid #01b0e0; border-radius: 6px; padding: 15px;}
.ReSearchScndFlatBig .map {height: auto;}
.objectInfo h4:first-child {margin-right: 15px;}
.objectAddress {display: flex; flex-wrap: wrap; justify-content: space-between; border-bottom: 1px solid #01b0e0; padding-bottom: 7px;}
.metro {display: flex; align-items: center; flex-wrap: wrap;}
.metroIc {margin-right: 7px;}
.metroIc {margin-bottom: 8px;}
.object-row {display: flex; justify-content: space-between; margin-bottom: 5px;}
.object-row > p:first-child {min-width: 100px; margin-right: 10px;}
.objectPass-row {display: flex; flex-wrap: wrap; justify-content: flex-end;}
.objectPass-row p {position: relative; padding-left: 10px;}
.objectPass-row p:not(:first-child)::before {
	content: '';
	position: absolute;
	height: 4px;
	width: 4px;
	border-radius: 50%;
	background: #ccc;
	left: 3px;
	top: 9px;
} 


.priceChart {display: flex; flex-direction: column;}
.bigPrice {width: 100%; padding: 15px; border-radius: 6px; background: linear-gradient(90deg, #1d83bd 0%, #00BF9A 100%); text-align: center; margin-bottom: 15px;}
.bigPrice h3, .bigPrice p {color: #fff;}


/*===chart===============================*/
.priceChart >>> .card-chart {border: 1px solid #01b0e0; border-radius: 6px;}
.priceChart >>> .card-chart h4 {margin-bottom: 0px;}
.priceChart >>> .card-chart .chart-area {height: auto;}

/*===mortgage===============================*/
.mortgage-title, .bank-header {display: flex; justify-content: space-between; flex-wrap: wrap; margin-bottom: 10px;}
.bank-header {display: flex; flex-wrap: nowrap;}
.bank-col {display: flex; flex-direction: column; justify-self: flex-end;}
.bank-col p {margin-bottom: 0px;}
.bank-text {display: flex; flex-direction: column;}
.mortgage-content {display: flex; flex-wrap: wrap;}
.banks {padding-left: 0px; padding-right: 5px;}
.banks-scroll {height: 500px; overflow-y: scroll; padding-right: 10px;}
.calcs {padding-right: 0px;}
.calcs >>> .input-group-append {cursor: pointer;}
.bank-photo-img {display: block; max-width: 100px; height: auto;}
.bank-card >>> .card-body {padding: 0px;}
.white-content .card:not(.card-white) .bank-card:hover {box-shadow: 0px 0px 10px rgba(139, 99, 127, 0.84); cursor: pointer;}
.bank-card:hover {box-shadow: 0px 0px 10px rgba(139, 99, 127, 0.84); cursor: pointer; border:1px solid #BA54F5;}
.bankselected {box-shadow: 0px 0px 10px rgba(139, 99, 127, 0.84); border:1px solid #BA54F5;}
.bank-card.active {box-shadow: 0px 0px 10px rgba(139, 99, 127, 0.84); border:1px solid #BA54F5;}
.IsBankTab {box-shadow: 0px 0px 10px rgba(139, 99, 127, 0.84); cursor: pointer; outline: none; border:1px solid #BA54F5;}
/*.bank-card:active {border:1px solid #BA54F5; box-shadow: 0px 0px 10px rgba(139, 99, 127, 0.84); cursor: pointer;}*/
.calc-row {display: flex; flex-wrap: wrap;}
.ReSearchScndFlatBig >>> .form-control + .input-group-append .input-group-text {background: transparent;}
.monthly-pay {display: flex; justify-content: space-between; flex-wrap: wrap;}
.monthly-pay h4 {color: #00bf9a;}
.gkTaskLink  {color: #9e77f3; font-weight: 300;}
.gkTaskLink:hover {color: #01b0e0; cursor: pointer;}
.ReSearchScndFlatBig >>> .bank-text br {content: ""; display: block; margin-top: 5px;}
.cell-agent {list-style: none; padding-left: 0px;}
.cell-agent p {display: inline-block;}

.callClass {border: 1px solid #01B0E0; border-radius: 6px; padding-top: 5px;}
.ReSearchScndFlatBig hr{
    color: #01B0E0;
    background-color: #01B0E0;
}    
.flat-carousel img {background-color: #fff;}

@media (max-width: 768px) {	
	.flatPass {margin-top: 20px; padding: 0px 10px 0px 5px!important;}
	.flatPass-btn {flex-wrap: wrap;}
	.flatPass-btn > button:first-child {margin-right: 0px;}
	.calcs {order: 1; margin-bottom: 20px;}
	.banks {order: 2; padding-right: 0px;}
	.monthly-pay h4 {margin-bottom: 0px;}
	.calcs {padding-left: 0px;}
	.bank-header {flex-wrap: wrap;}
	.mortgage-calc .btn, .flatHeader-btn {margin-top: 15px; width: 100%;}
	.flatHeader {padding: 15px 0px;}
	.cell-agent {flex-wrap: wrap;}
}

</style>
